// extracted by mini-css-extract-plugin
export var absolute = "Loading-module--absolute--r1VxF";
export var core = "Loading-module--core--lkOD6";
export var dash = "Loading-module--dash--lCpYf";
export var rotation = "Loading-module--rotation--BVuna";
export var spinner = "Loading-module--spinner--xUJgt";